/* eslint-disable react-hooks/exhaustive-deps */
import { gridStateActions, IGridState } from 'app/components/Common/Grid/GridStateManagement/GridState.redux';
import { selectGridState } from 'app/components/Common/Grid/GridStateManagement/GridState.selectors';
import { pageAttributesActions } from 'app/components/Placement/PlacementDetails/Edit/store/placementPageAttributes.redux';
import { getDetailsPageSupportComponentHeight } from 'app/layout/pages/DetailsPage';
import {
  gridTags,
  ITaskGridBody,
  StatusUpdateModalVersion,
  TaskEntity,
  TaskGridColumns,
  TaskStatus,
} from 'app/models/Tasks/Tasks';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _, { isArray } from 'lodash';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { XGrid, CustomTitleLink } from '../../Common/XGrid/XGrid';
import taskIcon from 'app/assets/images/folder.png';
import subTaskIcon from 'app/assets/images/subtask.png';
import { taskDetailsActions, taskDetailsReducer, taskDetailsSliceKey } from '../store/Tasks.redux';
import { taskDetailsSaga } from '../store/Tasks.saga';
import {
  selectedTaskGridDataItems,
  selectedTaskGridDataPaging,
  selectedUpdatedId,
  selectInternalTaskDetailsData,
  selectTaskEntity,
  selectTaskStatusUpdateFlag,
  selectVersionUpdated,
} from '../store/Tasks.selectors';
import { TaskDetails } from '../TaskDetails/TaskDetails';
import { selectUser } from 'oidc/user.selectors';
import { Chip } from '@mui/material';
import { missingField } from 'app/constants';
import { totalCountErrorThreshold } from 'store/redux-store/global-search/slice';
import {
  GridSortModel,
  GridCallbackDetails,
  GridColumnVisibilityModel,
  GridColumns as XGridColumns,
  GridApi,
} from '@mui/x-data-grid-pro';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import {
  checkRequiredFilters,
  filterDataList,
  getStatusChipColor,
  getStatusName,
  getTaskGridColumns,
  taskColumnVisibiltyModelOnTaskEntityChange,
  tasksColumnVisibilityModel,
} from './Transformers/helper';
import { DateRenderer } from './DateRenderer';
import { PastDueDateRenderer } from './PastDueDateRenderer';
import moment from 'moment-timezone';
import { GridColumns, SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { RootState } from 'types';
import { userDevicePreferenceActions } from 'oidc/UserDevicePreference/userPreference.redux';
import { SearchRecommendation } from './SearchRecommendation';
import { convertHexToRGBA } from 'app/helpers/colorHelpers';
import {
  setSessionValue,
  SessionKey,
  getSessionValue,
  StorageType,
} from 'utils/customHooks/sessionStorage/sessionHelpers';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const TasksGrid = ({ loading, gridTag, isLinkTaskMod, setGridErrorMessage, isExpanded, gridErrorMessage }) => {
  const gridApi = React.useRef<GridApi>();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUser);
  const userId = userInfo?.userInfo?.employeeId;
  const items = useSelector(selectedTaskGridDataItems);
  const paging = useSelector(selectedTaskGridDataPaging);
  const updatedId = useSelector(selectedUpdatedId);
  const versionStatusUpdated = useSelector(selectVersionUpdated);
  const taskDetails = useSelector(selectInternalTaskDetailsData);
  const userPreference = useSelector(selectUserPreference);
  const taskEntityValue = useSelector(selectTaskEntity);
  const gridState = useSelector(selectGridState);
  const taskStatusFlag = useSelector(selectTaskStatusUpdateFlag);
  const { filterAttributes } = gridState;
  const gridStateRef = useRef<IGridState>(gridState);
  gridStateRef.current = gridState;
  const [filteredDataList, setFilteredDataList] = useState<any[]>([]);
  const [dataList, setDataList] = useState<any[]>([]);
  const [titleLinkData, setTitleLinkData] = useState<any>([]);
  const [titleLink, setTitleLink] = useState(false);
  const [statusChanged, setStatusChanged] = useState<boolean | null>(null);
  const [taskId, setTaskId] = useState(0);
  const [copyOfFilters, setcopyOfFilters] = useState();
  const lastFetchedTaskEntityRef = useRef<number | undefined>(undefined);
  const prevTaskDetailsRef = useRef<typeof taskDetails>(undefined);
  useInjectSaga({ key: taskDetailsSliceKey, saga: taskDetailsSaga });
  useInjectReducer({ key: taskDetailsSliceKey, reducer: taskDetailsReducer });
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const defaultSortModel: any[] = [{ field: 'sentDate', sort: 'desc' }];
  const [currentSortModel, setCurrentSortModel] = React.useState<any[]>([{ field: 'sentDate', sort: 'desc' }]);
  const defaultColumns: any[] = [...getTaskGridColumns(t, taskEntityValue, ['brandId', 'taskId'])];
  const defaultColumnVisibilityModel: any = _.cloneDeep(tasksColumnVisibilityModel);
  const [currentColumns, setCurrentColumns] = React.useState<any[]>([
    ...getTaskGridColumns(t, taskEntityValue, ['brandId', 'taskId']),
  ]);
  const [currentColumnVisibilityModel, setCurrentColumnVisibilityModel] = React.useState<any>(
    _.cloneDeep(tasksColumnVisibilityModel),
  );
  const gridPreferences = useSelector((state: RootState) => {
    return state.userPreferenceData.userGridPreferences.find(item => item.id === gridTag);
  });
  const [searchSuggestion, setSearchSuggestion] = useState<boolean>();

  const getGroupViewLinkVals = (data, pagination) => {
    const groupView = { text: '', subDir1: '', subDir2: '', subDir3: '', chipSet: [], count: 0 };
    if (
      taskEntityValue === TaskEntity.PLACEMENTS &&
      gridState.filterAttributes?.selectedChipFilters.placementIds?.length > 0
    ) {
      groupView.text = data?.placementId;
      groupView.subDir1 = 'placement';
      groupView.subDir2 = data?.placementId;
      groupView.chipSet = gridState.filterAttributes?.selectedChipFilters.placementIds;
      groupView.count = pagination?.total;
    } else if (
      taskEntityValue === TaskEntity.CANDIDATES &&
      gridState.filterAttributes?.selectedChipFilters.candidateIds?.length > 0
    ) {
      groupView.text = data?.candidateName;
      groupView.subDir1 = 'candidate';
      groupView.subDir2 = data?.candidateId;
      groupView.subDir3 = data?.brandId;
      groupView.chipSet = gridState.filterAttributes?.selectedChipFilters.candidateIds;
      groupView.count = paging?.total;
    } else if (
      taskEntityValue === TaskEntity.FACILITIES &&
      gridState.filterAttributes?.selectedChipFilters.facilityIds?.length > 0
    ) {
      groupView.text = data?.facilityName;
      groupView.subDir1 = 'facility';
      groupView.subDir2 = data?.facilityId;
      groupView.chipSet = gridState.filterAttributes?.selectedChipFilters.facilityIds;
      groupView.count = paging?.total;
    } else if (
      taskEntityValue === TaskEntity.ORDERS &&
      gridState.filterAttributes?.selectedChipFilters.orderIds?.length > 0
    ) {
      groupView.text = data?.orderId;
      groupView.subDir1 = 'order';
      groupView.subDir2 = data?.orderId;
      groupView.chipSet = gridState.filterAttributes?.selectedChipFilters.orderIds;
      groupView.count = paging?.total;
    }
    setTitleLink(groupView.text !== '' && groupView.chipSet?.length === 1);
    return groupView;
  };

  const getPastDueDate = task => {
    return moment().isAfter(moment(task?.dueDate), 'day') &&
      task?.assignedTo?.some(
        assignee => assignee.statusId === TaskStatus.New || assignee.statusId === TaskStatus.Pending,
      )
      ? true
      : false;
  };

  const getDueDateinField = item => {
    const isPastDueDate = getPastDueDate(item);
    if (item?.dueDate && !isPastDueDate) {
      return <span style={{ paddingLeft: '21px' }}>{moment.tz(item.dueDate, 'America/Los_Angeles').format('L')}</span>;
    } else if (item?.dueDate && isPastDueDate) {
      return <PastDueDateRenderer date={item.dueDate} />;
    } else {
      return missingField;
    }
  };

  const FormatGridList = items =>
    items?.map((item, index) => {
      const data = {
        id: `${item.placementId}-${index}`,
        indexCounter: index,
        task: item.taskName ? item.taskName : missingField,
        taskCategory: item.taskCategory ? item.taskCategory : missingField,
        statusId: item.taskStatusId > 0 ? item.taskStatusId : missingField,
        rootTaskId: item.rootTaskId,
        originalTaskId: item.originalTaskId,
        description: item.taskDescription ? item.taskDescription : missingField,
        lastComment:
          isArray(item.comments) && item.comments.length ? item.comments[item.comments.length - 1].text : missingField,
        previewDrawerViewerId:
          isArray(item.comments) && item.comments.length ? item.comments[item.comments.length - 1].text : missingField,
        previewDrawerViewerType: 1,
        status:
          item.taskStatusId > 0 ? (
            <Chip
              size={'small'}
              style={{
                color: getStatusChipColor(item.taskStatusId),
                border: `1px solid ${getStatusChipColor(item.taskStatusId)}`,
                backgroundColor: convertHexToRGBA(getStatusChipColor(item.taskStatusId), 0.07),
              }}
              label={getStatusName(item.taskStatusId)}
            />
          ) : (
            missingField
          ),
        recipientStatus: item?.assignedTo,
        type:
          item.originalTaskId === 0 ? (
            <img alt="taskIcon" src={taskIcon} />
          ) : (
            <img alt="subTaskIcon" src={subTaskIcon} />
          ),
        dueDate: getDueDateinField(item),
        candidateId: item?.candidateId > 0 ? item?.candidateId : missingField,
        candidateName: item?.candidateId > 0 ? item.candidateFirstName + ' ' + item.candidateLastName : missingField,
        placementId: item?.placementId > 0 ? item?.placementId : missingField,
        orderId: item?.orderId > 0 ? item.orderId : missingField,
        facilityId: item?.facilityId > 0 ? item?.facilityId : missingField,
        facilityName: item?.facilityId > 0 ? item.facilityName : missingField,
        createdBy: item?.createdByFirstName ? item?.createdByFirstName + ' ' + item?.createdByLastName : missingField,
        brandId: item?.companyId ? item?.companyId : userInfo?.userInfo?.companyId,
        taskId: item?.taskId,
        sentTo: item?.assignedToList,
        sentDate: item?.createdDate ? <DateRenderer date={item.createdDate} /> : missingField,
      };
      return data;
    });

  const getVisibilityPreferences = (cols: any) => {
    const columnPreferences = gridPreferences?.value;
    if (columnPreferences && columnPreferences?.columnVisibilityModel) {
      return columnPreferences?.columnVisibilityModel;
    }
    return cols;
  };

  const getSortModelPreferences = (sortModel: any[]) => {
    const columnPreferences = gridPreferences?.value;
    if (columnPreferences && columnPreferences?.sortedColumn) {
      const preferenceSortModel = columnPreferences?.sortedColumn;
      return [{ field: preferenceSortModel?.column, sort: preferenceSortModel?.direction }];
    }
    return sortModel;
  };

  const getFetchSortColumn = (preferSavedPreferences = false) => {
    if (preferSavedPreferences) {
      return getSortModelPreferences(defaultSortModel)[0];
    }
    const gridSort = gridStateRef.current?.sortedColumn;
    if (gridSort?.column && gridSort?.direction) {
      return { field: gridSort.column, sort: gridSort.direction };
    }
    return currentSortModel[0] ?? getSortModelPreferences(defaultSortModel)[0];
  };

  const determineGridColumns = () => {
    const currentGridColumns = getColumnPreferences(defaultColumns);
    setCurrentColumns(currentGridColumns);
  };

  const determineVisibilityModel = () => {
    const currentVisibilityModel = getVisibilityPreferences(defaultColumnVisibilityModel);
    setCurrentColumnVisibilityModel(currentVisibilityModel);
  };

  const determineSortModel = () => {
    const currentGridSortModel = getSortModelPreferences(defaultSortModel);
    setCurrentSortModel(currentGridSortModel);
    if (
      !gridState?.sortedColumn ||
      (gridState?.sortedColumn &&
        (gridState.sortedColumn.column !== currentGridSortModel[0].field ||
          gridState.sortedColumn.direction !== currentGridSortModel[0].sort))
    ) {
      dispatch(
        gridStateActions.setSortedColumn({
          column: currentGridSortModel[0].field,
          direction: currentGridSortModel[0].sort,
        }),
      );
    }
  };

  useEffect(() => {
    const formatData = FormatGridList(filteredDataList);
    const titleLinkProps = getGroupViewLinkVals(formatData[0], paging);
    setTitleLinkData(titleLinkProps);
    setDataList(formatData);
  }, [filteredDataList]);

  useEffect(() => {
    if (!isLinkTaskMod) {
      if (taskEntityValue === TaskEntity.ALL) {
        determineVisibilityModel();
      } else {
        const visibilityModel = taskColumnVisibiltyModelOnTaskEntityChange(taskEntityValue);
        setCurrentColumnVisibilityModel(visibilityModel);
      }
    }
  }, [taskEntityValue]);

  const fetchGridData = (offset, page, sortedColumn) => {
    const { filterAttributes: currentFilterAttributes } = gridStateRef.current;
    const selectedCandidateIds = currentFilterAttributes?.selectedChipFilters?.candidateName
      ? currentFilterAttributes?.selectedChipFilters?.candidateIds?.concat(
          currentFilterAttributes?.selectedChipFilters?.candidateName?.filter(
            item => !currentFilterAttributes?.selectedChipFilters?.candidateIds?.includes(item),
          ),
        )
      : currentFilterAttributes?.selectedChipFilters?.candidateIds;

    const selectedFacilityIds = currentFilterAttributes?.selectedChipFilters?.facility
      ? currentFilterAttributes?.selectedChipFilters?.facilityIds?.concat(
          currentFilterAttributes?.selectedChipFilters?.facility?.filter(
            item => !currentFilterAttributes?.selectedChipFilters?.facilityIds?.includes(item),
          ),
        )
      : currentFilterAttributes?.selectedChipFilters?.facilityIds;

    dispatch(globalActions.closeBanner());
    const sortedColumnValue = sortedColumn?.field
      ? {
          column: sortedColumn?.field,
          direction: sortedColumn?.sort,
        }
      : sortedColumn;
    const body: ITaskGridBody = {
      entity: taskEntityValue,
      pageNumber: page,
      pageSize: offset,
      candidateId: selectedCandidateIds,
      placementId: currentFilterAttributes?.selectedChipFilters?.placementIds,
      facilityId: selectedFacilityIds,
      orderId: currentFilterAttributes?.selectedChipFilters?.orderIds,
      taskNameId: currentFilterAttributes?.selectedChipFilters?.taskName,
      taskCategory: currentFilterAttributes?.selectedChipFilters?.taskCategories,
      dueDateStart: currentFilterAttributes?.selectedChipFilters?.dueDateStart
        ? currentFilterAttributes?.selectedChipFilters?.dueDateStart
        : null,
      dueDateEnd: currentFilterAttributes?.selectedChipFilters?.dueDateEnd
        ? currentFilterAttributes?.selectedChipFilters?.dueDateEnd
        : null,
      assignedTo: currentFilterAttributes?.selectedChipFilters?.assignedToIds ?? [userId],
      createdBy: currentFilterAttributes?.selectedChipFilters?.createdByIds,
      taskStatusId: currentFilterAttributes?.selectedChipFilters?.taskStatusIds,
      sortedColumn: sortedColumnValue,
      translation: t,
    };
    dispatch(taskDetailsActions.taskGridDataAction(body));
  };

  useEffect(() => {
    setcopyOfFilters(undefined);
    lastFetchedTaskEntityRef.current = undefined;
    prevTaskDetailsRef.current = taskDetails;
  }, []);

  useEffect(() => {
    if (
      !taskDetails ||
      !filterAttributes ||
      _isEmpty(filterAttributes?.selectedChipFilters) ||
      isLinkTaskMod ||
      !userPreference?.loaded ||
      copyOfFilters === undefined
    ) {
      prevTaskDetailsRef.current = taskDetails;
      return;
    }

    if (prevTaskDetailsRef.current === taskDetails) {
      return;
    }

    prevTaskDetailsRef.current = taskDetails;
    fetchGridData(50, paging?.pageNumber ?? 1, getFetchSortColumn(false));
  }, [taskDetails, userPreference?.loaded, copyOfFilters]);

  useEffect(() => {
    if (filterAttributes && !_isEmpty(filterAttributes?.selectedChipFilters) && taskStatusFlag === 'REFRESH') {
      fetchGridData(50, 1, gridState?.sortedColumn ?? currentSortModel[0]);
      setcopyOfFilters(filterAttributes?.selectedChipFilters);
      lastFetchedTaskEntityRef.current = taskEntityValue;
      dispatch(taskDetailsActions.setTaskStatusUpdateModalId(undefined));
    }

    if (taskStatusFlag === 'SUCCESS') {
      setTaskId(0);
    }
  }, [taskStatusFlag]);

  useEffect(() => {
    if (
      filterAttributes &&
      !_isEmpty(filterAttributes?.selectedChipFilters) &&
      (versionStatusUpdated === StatusUpdateModalVersion.SUBTASK ||
        versionStatusUpdated === StatusUpdateModalVersion.PARENT_TASK)
    ) {
      fetchGridData(50, 1, gridState?.sortedColumn ?? currentSortModel[0]);
      setcopyOfFilters(filterAttributes?.selectedChipFilters);
      lastFetchedTaskEntityRef.current = taskEntityValue;
    }
  }, [versionStatusUpdated]);

  useEffect(() => {
    if (filterAttributes && !_isEmpty(filterAttributes?.selectedChipFilters)) {
      dispatch(
        gridStateActions.setGridAttributesState({
          gridTag,
          pageNumber: 1,
          pageSize: 50,
          previewItemId: -1,
          sortedColumn: { column: 'sentDate', direction: 'desc' },
          showPreviewDialog: false,
          saveAsDefaultView: false,
        }),
      );
    }
  }, [filterAttributes?.selectedChipFilters]);

  useEffect(() => {
    const taskEntityChanged = lastFetchedTaskEntityRef.current !== taskEntityValue;

    if (
      filterAttributes &&
      !_isEmpty(filterAttributes?.selectedChipFilters) &&
      (!_isEqual(filterAttributes?.selectedChipFilters, copyOfFilters) || updatedId || taskEntityChanged)
    ) {
      if (!isLinkTaskMod && !userPreference?.loaded) {
        dispatch(taskDetailsActions.setTaskGridData(null));
        return;
      }

      const requiredFiltersErrors = checkRequiredFilters(filterAttributes?.selectedChipFilters);
      if (!requiredFiltersErrors) {
        setSearchSuggestion(false);
        const isInitialPreferenceLoad = copyOfFilters === undefined;
        fetchGridData(50, 1, getFetchSortColumn(isInitialPreferenceLoad));
        setGridErrorMessage(null);
      } else {
        if (!isLinkTaskMod) {
          dispatch(
            globalActions.setBanner({
              ...requiredFiltersErrors,
              justify: 'start',
            }),
          );
        } else {
          setGridErrorMessage(requiredFiltersErrors?.message);
        }
        dispatch(taskDetailsActions.setTaskGridData(null));
        setSearchSuggestion(true);
      }
      setcopyOfFilters(filterAttributes?.selectedChipFilters);
      lastFetchedTaskEntityRef.current = taskEntityValue;
    }
  }, [filterAttributes?.selectedChipFilters, updatedId, userPreference?.loaded, taskEntityValue]);

  useEffect(() => {
    const data = filterDataList(items, filterAttributes?.selectedChipFilters, userId);
    setFilteredDataList(data);
  }, [filterAttributes, items]);

  /** X-Grid Implementation */
  const [gridHeight, setGridHeight] = React.useState<number | undefined>(window.innerHeight / 1.9);

  const updateGridHeight = () => {
    const a = document.getElementById('details-page-paper')?.offsetHeight;
    const b = getDetailsPageSupportComponentHeight();
    if (a && b) {
      // -100 to account for title
      setGridHeight(a - b - (document.getElementById('xgrid-title-container')?.offsetHeight ?? 0) - 12);
    } else {
      setGridHeight(600);
    }
    if (isLinkTaskMod) {
      const availableHeight = window.innerHeight - 226;
      if (isExpanded) {
        setGridHeight(availableHeight);
      } else {
        setGridHeight(availableHeight - 64);
      }
    }
  };

  const resizeGrid = React.useCallback(
    event => {
      updateGridHeight();
    },
    [filteredDataList, isExpanded],
  );

  React.useEffect(() => {
    updateGridHeight();
    window.addEventListener('resize', resizeGrid, true);
    return () => {
      window.removeEventListener('resize', resizeGrid);
    };
  }, [filteredDataList, resizeGrid, isExpanded]);

  React.useEffect(() => {
    if (userPreference?.loaded && !isLinkTaskMod) {
      dispatch(gridStateActions.setGrid(gridTag));
      determineGridColumns();
      determineVisibilityModel();
      determineSortModel();
    }
  }, [userPreference?.loaded]);

  const saveSortModel = React.useCallback(
    sortModel => {
      const sortedColumn =
        sortModel?.length > 0
          ? {
              column: sortModel[0].field,
              direction: sortModel[0].sort,
            }
          : undefined;
      if (!_.isEqual(sortedColumn, gridState?.sortedColumn)) {
        const preferenceData = {
          id: gridTag,
          value: {
            ...(gridPreferences?.value || {}),
            sortedColumn: sortedColumn,
          },
        };
        dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
      }
    },
    [currentColumnVisibilityModel, dispatch, gridPreferences?.value, gridState?.sortedColumn],
  );

  const onSortModelChanged = (model: GridSortModel, details: GridCallbackDetails) => {
    const pagination = gridApi?.current?.state?.pagination;
    if (pagination) {
      fetchGridData(
        pagination.pageSize,
        pagination.page + 1,
        model?.length > 0
          ? {
              column: model[0].field,
              direction: model[0].sort,
            }
          : { column: 'sentDate', direction: 'desc' },
      );
    }
    if (model?.length > 0) {
      saveSortModel(model);
    }
    setCurrentSortModel(model);
  };

  const getColumnPreferences = (cols: any[]) => {
    try {
      const columnPreferences = gridPreferences?.value;
      if (columnPreferences && columnPreferences.columns) {
        const newColumns = cols.map(column => {
          const foundIndex = columnPreferences.columns.findIndex(item => item?.field === column?.field);
          if (foundIndex !== -1) {
            return {
              ...column,
              ...columnPreferences.columns[foundIndex],
            };
          } else {
            return column;
          }
        });
        return newColumns.sort((a, b) => {
          return (
            columnPreferences.columns.findIndex(i => i.field === a.field) -
            columnPreferences.columns.findIndex(i => i.field === b.field)
          );
        });
      }
      return cols;
    } catch (err) {
      return cols;
    }
  };

  const savePreferences = React.useCallback(
    ({
      field,
      columns: gridColumns,
      visibilityModel,
    }: {
      field?: string;
      columns: XGridColumns;
      visibilityModel: GridColumnVisibilityModel;
    }) => {
      if (!isLinkTaskMod) {
        if (!currentColumns || currentColumns?.length === 0 || !userPreference.loaded) return;
        const currentGridColumns = new GridColumns(gridColumns).columns;

        if (currentGridColumns && currentGridColumns?.length > 0 && currentGridColumns[0].field === '__check__')
          currentGridColumns.shift();

        const comparableColumns = new GridColumns(
          gridPreferences?.value?.columns,
          gridPreferences?.value?.columnVisibilityModel,
        );
        const columnsEqual = comparableColumns.isEqual(currentGridColumns);
        const visibilityEqual = comparableColumns.isVisibilityModelEqual(visibilityModel);

        if (!columnsEqual || !visibilityEqual) {
          const preferenceData = {
            id: gridTag,
            value: {
              ...(gridPreferences?.value || {}),
              columns: currentGridColumns,
              columnVisibilityModel: visibilityModel,
            },
          };
          setSessionValue(
            SessionKey.tempColumnOrder,
            {
              ...getSessionValue(SessionKey.tempColumnOrder, StorageType.sessionStorage),
              columns: currentGridColumns,
              columnVisibilityModel: visibilityModel,
            },
            StorageType.sessionStorage,
          );
          dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
        }
      }
    },
    [currentColumns, userPreference.loaded, defaultColumns?.length, gridPreferences?.value, dispatch],
  );

  const onPageChange = (page: number, details: GridCallbackDetails) => {
    const pagination = gridApi?.current?.state?.pagination;
    if (pagination) {
      fetchGridData(pagination.pageSize, page + 1, gridState?.sortedColumn ?? currentSortModel[0]);
    }
  };

  const onPageSizeChange = (pageSize: number, details: GridCallbackDetails) => {
    const pagination = gridApi?.current?.state?.pagination;
    if (pagination) {
      fetchGridData(pageSize, pagination.page + 1, gridState?.sortedColumn ?? currentSortModel[0]);
    }
  };

  const changeStatus = params => {
    dispatch(taskDetailsActions.getCategoryListAction());
    if (params?.originalTaskId === 0) {
      setTaskId(params?.taskId);
    } else {
      setTaskId(params?.originalTaskId);
    }
  };

  const handleRefreshGrid = () => {
    const pagination = gridApi?.current?.state?.pagination;
    dispatch(placementModsAction.setSelectedTaskForMod(null));
    if (!gridErrorMessage) {
      fetchGridData(pagination.pageSize, pagination.page, gridState?.sortedColumn ?? currentSortModel[0]);
    }
  };

  const handleResetColumns = () => {
    const pagination = gridApi?.current?.state?.pagination;
    setCurrentColumns(getTaskGridColumns(t, taskEntityValue, ['brandId', 'taskId']));
    setCurrentColumnVisibilityModel(tasksColumnVisibilityModel);
    dispatch(gridStateActions.setSortedColumn({ column: 'sentDate', direction: 'desc' }));
    if (taskEntityValue === TaskEntity.ALL) {
      const preferenceData = {
        id: gridTag,
        value: {
          ...(gridPreferences?.value || {}),
          columns: defaultColumns,
          columnVisibilityModel: defaultColumnVisibilityModel,
          sortedColumn: { column: 'sentDate', direction: 'desc' },
        },
      };
      dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
    }

    if (!(currentSortModel[0]?.field === 'sentDate' && currentSortModel[0]?.sort === 'desc')) {
      fetchGridData(pagination.pageSize, pagination.page, defaultSortModel[0]);
    }
  };

  const onCellClick = params => {
    if (params?.field === TaskGridColumns.ASSIGNEDTO) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.CREATEDBY) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.DUEDATE) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.STATUS) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.TASK) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.TASKCATEGORY) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.CREATEDDATE) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.RECIPIENTSTATUS) {
      changeStatus(params?.row);
    } else if (params?.field === TaskGridColumns.TYPE) {
      changeStatus(params?.row);
    }
  };
  /** End X-Grid */

  useEffect(() => {
    if (taskId > 0) {
      setDetailsModalOpen(true);
    } else {
      setDetailsModalOpen(false);
    }
  }, [taskId]);

  const SearchXGrid = React.useMemo(() => {
    return (
      <XGrid
        apiRef={gridApi}
        loading={loading}
        hideFooterSelectedRowCount
        gridTag={gridTags.TASKGRIDTAG}
        rows={dataList || []}
        columns={currentColumns}
        autoHeight={false}
        height={gridHeight}
        rowsPerPageOptions={[50, 100, 150, 200, 250]}
        defaultRowsPerPage={gridState.pageSize || 50}
        paginationMode="server"
        sortingMode="server"
        defaultColumns={defaultColumns}
        inDialog={true}
        disableMultipleSelection={true}
        defaultColumnVisibilityModel={defaultColumnVisibilityModel}
        page={paging?.pageNumber && paging?.pageNumber - 1}
        rowCount={paging && paging?.total > totalCountErrorThreshold ? totalCountErrorThreshold : paging?.total}
        rowCountDisplay={paging?.total}
        onPageChange={onPageChange}
        disableSelectionOnClick={true}
        checkboxSelection={isLinkTaskMod}
        onSortModelChange={onSortModelChanged}
        showSelectedRowCount={false}
        onPageSizeChange={onPageSizeChange}
        defaultSortModel={defaultSortModel}
        columnVisibilityModel={currentColumnVisibilityModel}
        title={!titleLink || filteredDataList?.length === 0 ? t('notification.taskManagement.title') : ''}
        sortModel={currentSortModel}
        onColumnResizeStop={_columns => {
          if (taskEntityValue === TaskEntity.ALL && !isLinkTaskMod) {
            savePreferences({
              field: undefined,
              columns: _columns,
              visibilityModel: _.cloneDeep(currentColumnVisibilityModel ?? defaultColumnVisibilityModel),
            });
          }
        }}
        onColumnOrderChange={(params, event, details, _columns) => {
          if (taskEntityValue === TaskEntity.ALL && !isLinkTaskMod) {
            savePreferences({
              field: params.field,
              columns: _columns,
              visibilityModel: _.cloneDeep(currentColumnVisibilityModel ?? defaultColumnVisibilityModel),
            });
          }
        }}
        onColumnVisibilityModelChange={(model, details) => {
          if (!isLinkTaskMod) {
            dispatch(gridStateActions.setColumnVisibilityModel(model));
            setCurrentColumnVisibilityModel(_.cloneDeep(model));
            if (taskEntityValue === TaskEntity.ALL) {
              savePreferences({
                field: undefined,
                columns: _.cloneDeep(gridApi?.current?.getAllColumns()),
                visibilityModel: _.cloneDeep(model),
              });
            }
          }
        }}
        toolbarProps={{
          leftTitleAction:
            taskEntityValue && titleLink && filteredDataList?.length > 0 ? CustomTitleLink(titleLinkData) : null,
          refreshButton: true,
          columnSelector: isLinkTaskMod ? false : true,
          refreshGrid: () => {
            handleRefreshGrid();
          },
          resetColumns: () => {
            handleResetColumns();
            setCurrentSortModel(defaultSortModel);
            dispatch(
              globalActions.setSnackBar({
                message: 'Columns have been reset.',
                severity: 'success',
              }),
            );
          },
        }}
        onCellClick={onCellClick}
        disableStateRowSelection={true}
        components={{
          NoRowsOverlay:
            filterAttributes?.selectedChipFilters && searchSuggestion
              ? () => <SearchRecommendation entity={SearchType.tasks} />
              : undefined,
        }}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loading,
    dataList,
    currentColumns,
    paging,
    onPageChange,
    onSortModelChanged,
    defaultSortModel,
    onPageSizeChange,
    currentSortModel,
    gridHeight,
    taskEntityValue,
  ]);
  return (
    <>
      {SearchXGrid}
      {detailsModalOpen && (
        <TaskDetails
          taskID={taskId}
          open={detailsModalOpen}
          flag={false}
          setDetailsModalOpen={setDetailsModalOpen}
          handleClose={() => {
            setTaskId(0);
            dispatch(pageAttributesActions.setPopperOpen(false));
          }}
          setStatusChanged={setStatusChanged}
          statusChanged={statusChanged}
        />
      )}
    </>
  );
};
